import React__default from 'react';
import classNames from 'classnames';
import { NvTableWrapper } from '../NvTable/NvTableWrapper.esm.js';
import styles from './NvTableMarkdown.module.esm.js';

var NvTableMarkdown = function (_a) {
    var children = _a.children, classNames$1 = _a.classNames;
    return React__default.createElement(NvTableWrapper, { classNames: classNames(styles.wrapper, classNames$1) }, children);
};

export { NvTableMarkdown };
//# sourceMappingURL=NvTableMarkdown.esm.js.map
